import React, { FunctionComponent } from "react";
import { Claim } from "../../../../types";
import "../DetailView.css";
import { getStatusBadgeColor } from "../../../utils";

type BaseDetailsProps = {
  dataSelected: Claim;
};
const BaseDetails: FunctionComponent<BaseDetailsProps> = props => {
  const { dataSelected } = props;

  const getClaimBaseDetails = () => {
    if (!dataSelected) {
      return null;
    }

    return (
      <div className="format-section">
        <div className="format-fields">
          <div className="label">Claim Number</div>
          <div className="value">{dataSelected.claimNumber}</div>
        </div>
        <div className="format-fields">
          <div className="label">Status</div>
          <div className="value">
            <>
              <span
                className="badge badge-pill"
                style={{
                  padding: "0.25rem 0.5rem",
                  fontWeight: 500,
                  marginRight: "0.5rem",
                  marginBottom: "0.25rem",
                  fontSize: "11px",
                  color: getStatusBadgeColor(dataSelected.status).text,
                  backgroundColor: getStatusBadgeColor(dataSelected.status)
                    .background
                }}
              >
                {dataSelected.status}
              </span>
              <span
                className="badge badge-pill"
                style={{
                  padding: "0.25rem 0.5rem",
                  fontWeight: 500,
                  fontSize: "11px",
                  color: getStatusBadgeColor(dataSelected.claimProgress).text,
                  backgroundColor: getStatusBadgeColor(
                    dataSelected.claimProgress
                  ).background
                }}
              >
                {dataSelected.claimProgress}
              </span>
            </>
          </div>
        </div>

        <div className="format-section">
          {(dataSelected.street ||
            dataSelected.suburb ||
            dataSelected.city) && (
              <div className="format-fields">
                <div className="label">Address</div>
                <div>
                  <div className="value">{dataSelected.street}</div>
                  <div className="value">{dataSelected.suburb}</div>
                  <div className="value">{dataSelected.city}</div>
                </div>
              </div>
            )}
          {dataSelected.lossType && (
            <div className="format-fields">
              <div className="label">Loss Type</div>
              <div className="value">{dataSelected.lossType}</div>
            </div>
          )}
          {dataSelected.claimType && (
            <div className="format-fields">
              <div className="label">Claim Type</div>
              <div className="value">{dataSelected.claimType}</div>
            </div>
          )}

          <div className="format-fields">
            <div className="label" style={{ width: "200px" }}>Urgency <span style={{ fontSize: "0.7rem", background: "rgba(108,117,125, 0.2)", color: "rgb(52,57,62)", padding: "0.1rem 0.25rem", borderRadius: "0.25rem" }}>(1=Urgent / 4=Not Urgent)</span></div>
            <div className="value">{!!dataSelected.urgency ? dataSelected.urgency : <span>&#8212;</span>}</div>
          </div>

          {dataSelected.insuredName && (
            <div className="format-fields">
              <div className="label">Insured Name</div>
              <div className="value">{dataSelected.insuredName}</div>
            </div>
          )}
          {dataSelected.claimHandler && (
            <div className="format-fields">
              <div className="label">Claim Handler</div>
              <div className="value">{dataSelected.claimHandler}</div>
            </div>
          )}
          {dataSelected.vulnerability && (
            <div className="format-fields">
              <div className="label">Vulnerability</div>
              <div className="value">{dataSelected.vulnerability}</div>
            </div>
          )}
          {dataSelected.habitation && (
            <div className="format-fields">
            <div className="label">Habitation</div>
            <div className="value">
              <span
                className="badge badge-pill"
                style={{
                  padding: "0.25rem 0.5rem",
                  fontWeight: 500,
                  fontSize: "11px",
                  color: getStatusBadgeColor(dataSelected.habitation).text,
                  backgroundColor: getStatusBadgeColor(
                    dataSelected.habitation
                  ).background
                }}
              >
                {dataSelected.habitation}
              </span>
            </div>
            </div>
          )}
        </div>
      </div >
    );
  };

  return (
    <>
      <div className="detail-wrapper">
        <div className="heading">Claim Overview</div>
        {getClaimBaseDetails()}
      </div>
    </>
  );
};

export default BaseDetails;
